import React from 'react';
import BoutiqueText from "./BoutiqueText";
import BodiosYakDown from "../BodiosYakDown"; 

const textContent = [
  { text: "Yak" },
  { text: "Boutique" },
  { text: "we are bodios" }
];

function BoutiqueHeader() {
  return (
    <header
      className="flex flex-col text-center text-black uppercase"
      role="banner"
    >
      {/* Үндсэн дэвсгэр өнгө болон тохиргоо */}
      <div className="flex overflow-hidden flex-col justify-center items-center px-5 py-20 w-full bg-[#f4f3f1]">
        
        {/* Текст хэсэг */}
        <div className="flex flex-col items-center mb-10 max-w-full w-[1015px] text-center cursor-pointer text-8xl max-md:text-4xl">
          {textContent.map((item, index) => (
            <BoutiqueText key={index} text={item.text} isFirst={index === 0} />
          ))}
        </div>

        {/* Зурагтай компонент (Дотор нь оруулсан) */}
        <BodiosYakDown />

      </div>
    </header>
  );
}

export default BoutiqueHeader;